import api from '@/shared/api/api';

export const authApi = {
  /** Register a new user */
  register: (userData: any) => api.post('/auth/register', userData).then((r: any) => r.data),

  /** Resend email verification link */
  resendVerification: (email: any) => api.post('/auth/resend-verification', { email }).then((r: any) => r.data),

  /** Request password reset email */
  forgotPassword: (email: any) => api.post('/auth/forgot-password', { email }).then((r: any) => r.data),

  /** Reset password with token */
  resetPassword: (token: any, newPassword: any) =>
    api.post('/auth/reset-password', { token, new_password: newPassword }).then((r: any) => r.data),

  /** Verify email with token */
  verifyEmail: (token: any) => api.post('/auth/verify-email', { token }).then((r: any) => r.data),

  /** Exchange Google OAuth code for user data */
  googleCallback: (code: any, redirectUri: any) =>
    api
      .post('/auth/google/callback', { code, redirect_uri: redirectUri }, { withCredentials: true })
      .then((r: any) => r.data),

  /** Set role for a Google-authenticated user */
  googleSetRole: (data: any) =>
    api.post('/auth/google/set-role', data, { withCredentials: true }).then((r: any) => r.data),
};
